import { render, staticRenderFns } from "./ShippingHeaderSearch.vue?vue&type=template&id=3f8e50a4"
import script from "./ShippingHeaderSearch.vue?vue&type=script&lang=js"
export * from "./ShippingHeaderSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports